/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Документ внутри папки пользовательских документов
 * @export
 * @interface UserDocument
 */
export interface UserDocument {
  /**
   * UUID документа
   * @type {string}
   * @memberof UserDocument
   */
  uuid: string
  /**
   * Название документа
   * @type {string}
   * @memberof UserDocument
   */
  name: string
  /**
   * Название типа документа (справочник DocumentType)
   * @type {string}
   * @memberof UserDocument
   */
  documentType: string
  /**
   * Дата создания документа
   * @type {string}
   * @memberof UserDocument
   */
  createdAt: string
  /**
   * Временная ссылка на файл документа; null, если файл недоступен
   * @type {string}
   * @memberof UserDocument
   */
  temporaryUrl: string | null
}

/**
 * Check if a given object implements the UserDocument interface.
 */
export function instanceOfUserDocument(value: object): value is UserDocument {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('documentType' in value) || value['documentType'] === undefined)
    return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('temporaryUrl' in value) || value['temporaryUrl'] === undefined)
    return false
  return true
}

export function UserDocumentFromJSON(json: any): UserDocument {
  return UserDocumentFromJSONTyped(json, false)
}

export function UserDocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserDocument {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    documentType: json['documentType'],
    createdAt: json['createdAt'],
    temporaryUrl: json['temporaryUrl'],
  }
}

export function UserDocumentToJSON(value?: UserDocument | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    documentType: value['documentType'],
    createdAt: value['createdAt'],
    temporaryUrl: value['temporaryUrl'],
  }
}
